import { MigrationSpec } from "../migration.models"

const metaAdsReportWidgetTemplates: MigrationSpec = {
  type: "SEED_META_ADS_REPORT_WIDGET_TEMPLATES",
  collection: "ReportWidgetTemplates",
  risk: "SAFE",
  title: {
    en: "Meta Ads → report widget templates",
    tr: "Meta Ads → rapor widget şablonları"
  },
  description: {
    en:
      "Inserts the five `meta_ads` report widget templates when missing: conversations " +
      "(`meta_ads_conversations`), clicks (`meta_ads_clicks`), conversions " +
      "(`meta_ads_conversions`), performance (`meta_ads_performance`) and conversion value " +
      "(`meta_ads_conversion_value`). Written with `$setOnInsert`, so a second run changes " +
      "nothing and existing (possibly edited) templates are never overwritten.",
    tr:
      "Eksikse beş `meta_ads` rapor widget şablonunu ekler: konuşmalar " +
      "(`meta_ads_conversations`), tıklamalar (`meta_ads_clicks`), dönüşümler " +
      "(`meta_ads_conversions`), performans (`meta_ads_performance`) ve dönüşüm değeri " +
      "(`meta_ads_conversion_value`). `$setOnInsert` ile yazılır: ikinci çalıştırma hiçbir şey " +
      "değiştirmez, mevcut (düzenlenmiş olabilecek) şablonların üzerine asla yazılmaz."
  },
  expectedDocuments: {
    filter: {
      dataSource: "meta_ads",
      widgetType: {
        $in: [
          "meta_ads_conversations",
          "meta_ads_clicks",
          "meta_ads_conversions",
          "meta_ads_performance",
          "meta_ads_conversion_value"
        ]
      }
    },
    count: 5
  },
  notes: [
    {
      en:
        "Run after “Meta Ads → report metric templates”: these widgets reference those metric " +
        "templates.",
      tr:
        "“Meta Ads → rapor metrik şablonları”ndan sonra çalıştırın: bu widget'lar o metrik " +
        "şablonlarına referans verir."
    },
    {
      en:
        "Deploy the api-v2 build that serves the `meta_ads` data source first — an older build " +
        "cannot render these widgets.",
      tr:
        "Önce `meta_ads` veri kaynağını sunan api-v2 sürümünü deploy edin — eski sürüm bu " +
        "widget'ları gösteremez."
    },
    {
      en:
        "After this and the metric templates have run, press “Create Default System Reports” " +
        "(CREATE_DEFAULT_SYSTEM_REPORTS) on the Scripts page once so tenants get the Meta Ads " +
        "system report. Until then that report is skipped for every tenant.",
      tr:
        "Bu ve metrik şablonları çalıştıktan sonra, tenant'ların Meta Ads sistem raporunu alması " +
        "için Scripts sayfasındaki “Create Default System Reports” " +
        "(CREATE_DEFAULT_SYSTEM_REPORTS) düğmesine bir kez basın. O zamana kadar bu rapor her " +
        "tenant için atlanır."
    }
  ]
}

export default metaAdsReportWidgetTemplates
